"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrainGraphqlAdapter = exports.BrainAdapter = void 0;
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
const RestClient_1 = require("../cutil/RestClient");
const Settings_1 = require("../kernel/Settings");
const ErrorUtil_1 = require("../api/ErrorUtil");
const Eventbus_1 = require("../cutil/Eventbus");
const UnauthorizedMsg_1 = require("../msg/UnauthorizedMsg");
const StreamClient_1 = require("../cutil/StreamClient");
class BrainAdapter {
    constructor(authStore, projectStore) {
        this.authStore = authStore;
        this.projectStore = projectStore;
    }
    errorHandler(error) {
        if (error instanceof RestClient_1.RestResponse) {
            // 提前注入错误处理函数，会被 API 的 parseError 重写
            error.parseError(res => {
                const errorFromApi = ErrorUtil_1.ErrorUtil.parseRestResponse(res);
                return errorFromApi || ErrorUtil_1.ErrorUtil.defaultErrorMsg;
            });
            if (error.status == 401) {
                this.authStore.logout();
                Eventbus_1.eventbus.emit(new UnauthorizedMsg_1.UnauthorizedMsg());
            }
        }
        else if (error instanceof StreamClient_1.StreamInternalError) {
            error.parseError(res => {
                if (error.jsonData.name === ErrorUtil_1.ErrorUtil.abortErrorName) {
                    return ErrorUtil_1.ErrorUtil.defaultErrorMsg;
                }
                const errorFromApi = ErrorUtil_1.ErrorUtil.parseErrorData(error.jsonData).result;
                return errorFromApi || ErrorUtil_1.ErrorUtil.defaultErrorMsg;
            });
        }
        else if (error instanceof RestClient_1.RestInternalError) {
            error.parseError(res => {
                /// 基本库直接抛出的错误，不用解析，直接显示默认文本
                return ErrorUtil_1.ErrorUtil.defaultErrorMsg;
            });
        }
    }
    get headers() {
        const brainToken = this.authStore.state.brainToken;
        const guestToken = this.authStore.state.guestToken;
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let header = {
            "X-Brain-User-Tz": tz,
            "Content-Type": "application/json",
        };
        if (!(0, is_blank_1.default)(brainToken)) {
            header["Authorization"] = `token ${brainToken}`;
        }
        else if (!(0, is_blank_1.default)(guestToken)) {
            header["Brain-Guest-User-Key"] = guestToken;
        }
        const attrIndexer = this.projectStore.attrIndexer;
        if (!(0, is_blank_1.default)(attrIndexer)) {
            header["X-Brain-Imagica-Id"] = attrIndexer;
        }
        return header;
    }
    get baseUrl() {
        return Settings_1.settings.API;
    }
    get contentType() {
        return RestClient_1.RestContentType.json;
    }
}
exports.BrainAdapter = BrainAdapter;
class BrainGraphqlAdapter extends BrainAdapter {
    get baseUrl() {
        return Settings_1.settings.API + "/api/social/";
    }
}
exports.BrainGraphqlAdapter = BrainGraphqlAdapter;
